'use client';
import { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';
import { ApiProvider } from './ApiContext';
import { ShowProvider } from './ShowContext';
import { useAuth } from './AuthContext';
import { ToastProvider } from './ToastContext';

/**
 * Internal component that bridges ApiProvider with AuthContext
 * This must be inside AuthProvider to use useAuth
 */
function ApiProviderBridge({ children }: { children: ReactNode }) {
  const { setUser } = useAuth();

  return (
    <ApiProvider onUserSync={setUser}>
      {children}
    </ApiProvider>
  );
}

/**
 * Combined providers for the app
 * Ensures correct provider nesting order:
 * AuthProvider -> ApiProvider -> ShowProvider -> ToastProvider
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <ApiProviderBridge>
        <ShowProvider>
          <ToastProvider>
            {children}
          </ToastProvider>
        </ShowProvider>
      </ApiProviderBridge>
    </AuthProvider>
  );
}
